import { Expose } from 'class-transformer'

export class SubCorrectionDetailType {
  @Expose() old: string | string[]

  @Expose() new: string | string[]
}
